import React, {useState} from 'react';
import List from "@mui/material/List";
import ProjectInstanceListItem from "src/components/project/ProjectInstanceListItem";
import {Typography} from "@mui/material";

const ProjectInstanceList = ({projectInstances, selectedProjectInstance, setSelectedProjectInstance, onChange}) => {
    if (!projectInstances) {
      return <Typography variant="body1">Geen afspraakmogelijkheden op deze datum.</Typography>
    }

    const listItemOnClick = (projectInstance) => {
      setSelectedProjectInstance(projectInstance);

      if (onChange) {
        onChange(projectInstance);
      }
    }

  return (
    <List>
      {projectInstances.map((projectInstance) => (
          <ProjectInstanceListItem
            key={projectInstance.id}
            projectInstance={projectInstance}
            isSelected={selectedProjectInstance && selectedProjectInstance.id === projectInstance.id}
            onClick={listItemOnClick}
          />
      ))}
    </List>
  );
}

export default ProjectInstanceList;

ProjectInstanceList.propTypes = {};

ProjectInstanceList.defaultProps = {};
